/**
 * Estado global da aplicação
 * Armazena informações importantes que precisam ser acessadas em todo o código
 */

interface AppState {
  // Informações do usuário logado
  user: {
    id?: string;
    email?: string;
    empresa?: string;
    codusur?: string;
    rotaApi?: string; // Rota da API para a empresa do usuário
  };
}

// Estado inicial da aplicação
const initialState: AppState = {
  user: {}
};

// Estado global da aplicação
let appState: AppState = { ...initialState };

/**
 * Funções para manipular o estado global
 */
export const appStateService = {
  /**
   * Retorna o estado atual da aplicação
   */
  getState(): AppState {
    return appState;
  },

  /**
   * Atualiza o estado da aplicação
   * @param newState Novo estado parcial
   */
  updateState(newState: Partial<AppState>): void {
    appState = {
      ...appState,
      ...newState
    };
    console.log('Estado da aplicação atualizado:', appState);
  },

  /**
   * Atualiza as informações do usuário
   * @param userData Dados do usuário
   */
  updateUserData(userData: Partial<AppState['user']>): void {
    appState.user = {
      ...appState.user,
      ...userData
    };
    console.log('Dados do usuário atualizados:', appState.user);
  },

  /**
   * Limpa o estado da aplicação (logout)
   */
  clearState(): void {
    appState = { ...initialState };
    console.log('Estado da aplicação limpo');
  },

  /**
   * Retorna a rota da API para a empresa do usuário
   */
  getApiRoute(): string {
    if (!appState.user.rotaApi) {
      console.error('Rota da API não encontrada no estado da aplicação');
    }
    return appState.user.rotaApi || '';
  }
};
